import moment from 'moment';

export const getDeclarationQuestions = (object) => {
  if (object === null) {
    return null;
  }
  switch (object?.name) {
    case 'global': {
      return [
        {
          type: 'field',
          key: 'Full Name',
          value: `${object?.userId?.firstName} ${object?.userId?.lastName}`,
        },
        {
          type: 'field',
          key: 'Email',
          value: object?.userId?.email,
        },
        {
          type: 'field',
          key: 'Phone Number',
          value: object?.userId?.phone,
        },
        // { type: 'field', key: 'Company Name', value: object.user.company },
        {
          type: 'field',
          key: 'Expected Departure',
          value: moment(object?.declarationForm?.expectedDepartureDate).format(
            'DD/MM/YYYY hh:mm A'
          ),
        },
        {
          type: 'question',
          key: '1. Are other people travelling onto the property with you?',
          value:
            object?.declarationForm?.userTravelingAlong?.length > 0
              ? object?.declarationForm?.userTravelingAlong.join(',')
              : 'No',
        },
        {
          type: 'question',
          key: '2. Have all visitors had a Q Fever vaccination?',
          value: object?.declarationForm?.isQfeverVaccinated ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '3. Does anyone have cold or flu symptoms?',
          value: object?.declarationForm?.isFluSymptoms ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '4. Have any visitors been overseas in the last 7 days?',
          value: object?.declarationForm?.isOverSeaVisit ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '5. Have you taken all reasonable measures to ensure that shoes, clothing and equipment are free from potential weed and disease contaminants:',
          value: object?.declaration?.isAllMeasureTaken ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '6. Have you made reasonable attempts to notify the owner/manager of the property that you are visiting today?',
          value: object?.declarationForm?.isOwnerNotified ? 'Yes' : 'No',
        },
        { type: 'question', key: 'Rego', value: object?.declarationForm?.rego },
        { type: 'question', key: 'Risk Rating', value: object?.declarationForm?.riskRating },
      ];
    }
    case 'WARAKIRRI_DECLARATION': {
      return [
        {
          type: 'field',
          key: 'Full Name',
          value: `${object?.userId?.firstName} ${object?.userId?.lastName}`,
        },
        {
          type: 'field',
          key: 'Email',
          value: object?.userId?.email,
        },
        {
          type: 'field',
          key: 'Phone Number',
          value: object?.userId?.phone,
        },
        {
          type: 'field',
          key: 'Risk Rating',
          value: object?.riskRating,
        },
        {
          type: 'field',
          key: 'Geofence Name',
          value: object?.geofenceName,
        },
        {
          type: 'question',
          key: '1. Have you been overseas in the past 7 days ?',
          value: object?.traveledOverseas ? 'Yes' : 'No',
          isExtra: object?.traveledOverseas,
          title: 'Countries Visited',
          extraValue: object?.countries?.length > 0 ? object?.countries[0] : '',
        },
        {
          type: 'question',
          key: '2. Do you have any Cold or Flue Symptoms ?',
          value: object?.hasColdOrFluSymptoms ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '3. Have you had a Q Fever vaccination?',
          value: object?.hadQFeverVaccination ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '4. Are you clean from contaminants ?',
          value: object?.isClean ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '5. Have you been inducted to the site ?',
          value: object?.inducted ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '6. Does the work being undertaken involve exposure to Confined Spaces, Native Vegetation Clearing ?',
          value: object?.workIsHazardous ? 'Yes' : 'No',
          isLongLine: true,
        },
        {
          type: 'question',
          key: '7. Are you working on any plant that needs to be isolated ?',
          value: object?.workingWithIsolatedPlants ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '8. Additional Info',
          value: object?.additionalInformation,
        },
        {
          type: 'declaration',
          value:
            'I declare that any animals / products I am transporting are accompanied by correct documentation.',
        },
        {
          type: 'sign',
          key: 'Signature',
          date: object?.createdAt,
          value: object?.signature,
        },
      ];
    }
    case 'DEFAULT_AU': {
      return [
        {
          type: 'field',
          key: 'Full Name',
          value: `${object?.userId?.firstName} ${object?.userId?.lastName}`,
        },
        {
          type: 'field',
          key: 'Email',
          value: object?.userId?.email,
        },
        {
          type: 'field',
          key: 'Phone Number',
          value: object?.userId?.phone,
        },
        {
          type: 'field',
          key: 'Premise',
          value: object?.geofenceId?.premiseId?.propertyName,
        },
        {
          type: 'field',
          key: 'Geofence Name',
          value: object?.geofenceId?.name,
        },
        {
          type: 'question',
          key: '1. Have you been overseas in the last 14 days?',
          value: object?.traveledOverseas ? 'Yes' : 'No',
          isExtra: object?.traveledOverseas,
          title: 'Countries Visited',
          extraValue: object?.countries?.length > 0 ? object?.countries[0] : 'Not available',
        },
        {
          type: 'question',
          key: '2. Do you have any cold or flu symptoms?',
          value: object?.hasColdOrFluSymptoms ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '3. Have you had a QFever vaccination?',
          value: object?.hadQFeverVaccination ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '4. Have you taken all reasonable measures to ensure that shoes, clothing and equipment are free from potential contaminants?',
          value: object?.isClean ? 'Yes' : 'No',
          longText: true,
        },
        {
          type: 'question',
          key: '5. Are you transporting any livestock?',
          value: 'No',
        },
        {
          type: 'question',
          key: '6. Are you transporting produce, fodder, grain or fertiliser?',
          value: 'No',
        },
        {
          type: 'question',
          key: '7. Are you alone or traveling with people?',
          value: object?.travelingPeople ? 'Alone' : 'With people',
          isExtra: !object?.travelingPeople,
          title: 'Travelling with',
          extraValue: object?.travelingPeopleNames,
        },
        {
          type: 'question',
          key: '8. Method of entry?',
          value: 'Other',
          isExtra: object?.methodOfEntry,
          title: 'Details',
          extraValue: object?.entryDetails,
        },
        {
          type: 'declaration',
          value:
            'I declare that all questions are correct and that all regulatory documentation is complete.',
        },
        {
          type: 'sign',
          key: 'Signature',
          date: object?.createdAt,
          value: object?.signature,
        },
      ];
    }
    case 'DEFAULT_US': {
      // return [
      //   {
      //     type: 'field',
      //     key: 'Full Name',
      //     value: `${object?.userId?.firstName} ${object?.userId?.lastName}`,
      //   },
      //   {
      //     type: 'field',
      //     key: 'Email',
      //     value: object?.userId?.email,
      //   },
      //   {
      //     type: 'field',
      //     key: 'Phone Number',
      //     value: object?.userId?.phone,
      //   },
      //   {
      //     type: 'field',
      //     key: 'Premise',
      //     value: object?.geofenceId?.premiseId?.propertyName,
      //   },
      //   {
      //     type: 'field',
      //     key: 'Geofence Name',
      //     value: object?.geofenceId?.name,
      //   },
      //   {
      //     type: 'question',
      //     key: '1. Have you been overseas in the last 2 months ?',
      //     value: object?.traveledOverseas ? 'Yes' : 'No',
      //     isExtra: object?.traveledOverseas,
      //     title: 'Countries Visited',
      //     extraValue: object?.countries?.length > 0 ? object?.countries[0] : 'Not available',
      //   },
      //   {
      //     type: 'question',
      //     key: '2. Do you have any Cold or Flue Symptoms ?',
      //     value: object?.hasColdOrFluSymptoms ? 'Yes' : 'No',
      //   },
      //   {
      //     type: 'question',
      //     key: '3. Have you had a Q Fever vaccination ?',
      //     value: object?.hadQFeverVaccination ? 'Yes' : 'No',
      //   },
      //   {
      //     type: 'question',
      //     key: '4. Are you clean from contaminants ?',
      //     value: object?.isClean ? 'Yes' : 'No',
      //   },
      //   {
      //     type: 'question',
      //     key: '5. Vehicle Registration',
      //     value: object?.rego,
      //   },
      //   {
      //     type: 'question',
      //     key: '6. Risk Rating',
      //     value: object?.riskRating,
      //   },
      //   {
      //     type: 'declaration',
      //     value:
      //       'I declare that any animals / products I am transporting are accompanied by correct documentation.',
      //   },
      //   {
      //     type: 'sign',
      //     key: 'Signature',
      //     date: object?.createdAt,
      //     value: object?.signature,
      //   },
      // ];

      return [
        {
          type: 'field',
          key: 'Full Name',
          value: `${object?.userId?.firstName} ${object?.userId?.lastName}`,
        },
        {
          type: 'field',
          key: 'Address',
          value: `${object?.userId?.addressStreet}, ${object?.userId?.addressTown}, ${object?.userId?.addressState}, ${object?.userId?.addressCountry}`,
        },

        {
          type: 'field',
          key: 'Email',
          value: object?.userId?.email,
        },
        {
          type: 'field',
          key: 'Phone Number',
          value: object?.userId?.phone,
        },
        {
          type: 'field',
          key: 'Premise',
          value: object?.geofenceId?.premiseId?.propertyName,
        },
        {
          type: 'field',
          key: 'Geofence Name',
          value: object?.geofenceId?.name,
        },
        {
          type: 'question',
          key: '1. Have you been overseas in the last 14 days ?',
          value: object?.traveledOverseas ? 'Yes' : 'No',
          isExtra: object?.traveledOverseas,
          title: 'Countries Visited',
          extraValue: object?.countries?.length > 0 ? object?.countries[0] : 'Not available',
        },
        {
          type: 'question',
          key: '2. Do you have any Cold or Flu Symptoms ?',
          value: object?.hasColdOrFluSymptoms ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '3. Are you by yourself or do you have addition persons?',
          value: object?.travelingPeople ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '4. Mode of Entry',
          value:
            object?.methodOfEntry !== null
              ? object?.methodOfEntry
                ? 'Vehicle'
                : 'Walk/Ride/Other'
              : 'Not Specified',
          isExtra: object?.methodOfEntry,
          title: 'Details',
          extraValue: object?.entryDetails,
        },
        {
          type: 'question',
          key: '5. Additional information',
          value: object?.additionalInformation ?? 'Not Specified',
        },
        {
          type: 'declaration',
          value:
            'I declare that any animals / products I am transporting are accompanied by correct documentation.',
        },
        {
          type: 'sign',
          key: 'Signature',
          date: object?.createdAt,
          value: object?.signature,
        },
      ];
    }
    case 'DEFAULT': {
      return [
        {
          type: 'field',
          key: 'Full Name',
          value: `${object?.userId?.firstName} ${object?.userId?.lastName}`,
        },
        {
          type: 'field',
          key: 'Address',
          value: `${object?.userId?.addressStreet}, ${object?.userId?.addressTown}, ${object?.userId?.addressState}, ${object?.userId?.addressCountry}`,
        },
        {
          type: 'field',
          key: 'Email',
          value: object?.userId?.email,
        },
        {
          type: 'field',
          key: 'Phone Number',
          value: object?.userId?.phone,
        },
        {
          type: 'field',
          key: 'Premise',
          value: object?.geofenceId?.premiseId?.propertyName,
        },
        {
          type: 'field',
          key: 'Geofence Name',
          value: object?.geofenceId?.name,
        },
        {
          type: 'question',
          key: '1. Have you been overseas in the last 14 days ?',
          value: object?.traveledOverseas ? 'Yes' : 'No',
          isExtra: object?.traveledOverseas,
          title: 'Countries Visited',
          extraValue: object?.countries?.length > 0 ? object?.countries[0] : 'Not available',
        },
        {
          type: 'question',
          key: '2. Do you have any Cold or Flu Symptoms ?',
          value: object?.hasColdOrFluSymptoms ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '3. Are you by yourself or do you have addition persons?',
          value: object?.travelingPeople ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '4. Mode of Entry',
          value:
            object?.methodOfEntry !== null
              ? object?.methodOfEntry
                ? 'Vehicle'
                : 'Walk/Ride/Other'
              : 'Not Specified',
          isExtra: object?.methodOfEntry,
          title: 'Details',
          extraValue: object?.entryDetails,
        },
        {
          type: 'question',
          key: '5. Additional information',
          value: object?.additionalInformation ?? 'Not Specified',
        },
        {
          type: 'declaration',
          value:
            'I declare that any animals / products I am transporting are accompanied by correct documentation.',
        },
        {
          type: 'sign',
          key: 'Signature',
          date: object?.createdAt,
          value: object?.signature,
        },
      ];
    }
    case 'AUSNET_DECLARATION': {
      return [
        { type: 'title', text: 'Property & Landholder Details :-' },
        {
          type: 'field',
          key: object?.isLandholderPresent ? 'LandHolder Name' : 'Nominated Representative Present',
          value: object?.landHolderName ?? object?.nameOfRepresentativePresent,
        },
        {
          type: 'field',
          key: 'Premise',
          value: object?.geofenceId?.premiseId?.propertyName,
        },
        {
          type: 'field',
          key: 'Geofence',
          value: object?.geofenceId?.name,
        },
        {
          type: 'field',
          key: 'Geofence co-ordinates',
          value: object?.breachLocation,
        },
        { type: 'title', text: 'Visitors Details :-' },
        {
          type: 'field',
          key: 'Full Name',
          value: `${object?.userId?.firstName} ${object?.userId?.lastName}`,
        },
        {
          type: 'field',
          key: 'Phone Number',
          value: object?.userId?.phone,
        },
        {
          type: 'field',
          key: 'Email',
          value: object?.userId?.email,
        },

        { type: 'title', text: 'Normal Checking Question :-' },
        {
          type: 'question',
          key: '1. Have you or anyone in your group been overseas in the last seven days?',
          value: object?.didTravelOverseas ? 'yes' : 'No',
        },
        {
          type: 'question',
          key: '2. Do you or anyone in your group have any Cold or Flu Symptoms?',
          value: object?.hasColdOrFluSymptoms ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '3. Have you or anyone in your group had a Q Fever vaccination?',
          value: object?.hadQFeverVaccination ? 'Yes' : 'No',
          isExtra: object?.hadQFeverVaccination,
          title: 'Vaccination Year',
          extraValue: object?.qFeverVaccinationDate,
        },
        {
          type: 'question',
          key: '4. Are you transporting any Materials, Plant or Equipment which hasn’t a completed Materials Movement Declaration (eMMD)?',
          value: object?.isCleanFromContaminants ? 'Yes' : 'No',
          longText: true,
        },
        {
          type: 'question',
          key: '5. Do you have someone with you?',
          value: object?.isTravelingWithGroup ? 'Yes' : 'No',
          isExtra: object?.isTravelingWithGroup,
          title: 'Travelling with',
          extraValue: object?.travelingWith,
        },
        {
          type: 'question',
          key: '6. Have you and/or all your group completed a BOOT WASH prior to entering this site?',
          value: object?.priorBootWash ? 'Yes' : 'No',
        },

        {
          type: 'field',
          key: 'Mode of Entry',
          value:
            object?.methodOfEntry !== null
              ? object?.methodOfEntry
                ? 'Drive'
                : 'Walk/Ride/Other'
              : 'Not Specified',
        },
        {
          type: 'question',
          key: '7. Has the Vehicle arrived at site clean?',
          value: object?.isVehicleClean ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '8. Has the Materials, Plant & Equipment arrived at site clean?	',
          value: object?.isMaterialAndEquipmentClean ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '9. Has the Vehicle been BIO-WASHED at an approved Washout Facility?',
          value: object?.isVehicleBioWashed ? 'Yes' : 'No',
        },
        {
          type: 'question',
          key: '10. Has the Materials, Plant & Equipment been BIO-WASHED at an approved Washout Facility?',
          value: object?.isMaterialAndEquipmentBioWashed ? 'Yes' : 'No',
        },
        {
          type: 'field',
          key: 'CHEMICALS USED IN BIOWASH',
          value: object?.chemicalsUsedInBioWash,
        },

        {
          type: 'field',
          key: 'Risk Rating',
          value: object?.riskRating,
        },
        {
          type: 'declaration',
          value:
            'I declare that any products I am transporting are accompanied by the appropriate documentation.',
        },
        {
          type: 'sign',
          key: 'Signature',
          date: object?.createdAt,
          value: object?.signature,
        },
      ];
    }
    default: {
      return null;
    }
  }
};

export function extractData(dataArray) {
  if (dataArray && dataArray?.length > 0) {
    const extractedData = dataArray?.map((item) => {
      return {
        VisitorName: `${item?.userId?.firstName} ${item?.userId?.lastName}`,
        Company: item?.companyId?.name,
        premiseName: item?.premiseId?.propertyName,
        Geofence: item?.geofenceId?.name,
        serviceRole: item?.serviceRole,
        Date: moment(item.entryDate).format('DD-MM-YYYY'),
        entryTime: item.entryDate ? moment(item.entryDate).format('HH:mm:ss A').toString() : '',
        exitTime: item.exitDate ? moment(item.exitDate).format('HH:mm:ss A').toString() : '',
      };
    });
    return { bioplusUsers: extractedData };
  } else {
    return {
      bioplusUsers: [
        {
          VisitorName: '',
          Company: '',
          premiseName: '',
          Geofence: '',
          serviceRole: '',
          Date: '',
          entryTime: '',
          exitTime: '',
        },
      ],
    };
  }
}
